import { makeStyles } from '@material-ui/core/styles';

// SideBySideViewComponent Styles
export const useSideBySideViewStyles = makeStyles((theme) => ({
  rowContainer: {
    display: 'flex',
    width: '100%',
    padding: '12px 0',
    height: 'var(--dashboard-container-max-height)',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: 'auto'
    }
  },
  left: {
    width: 400,
    flexShrink: 0,
    height: 'auto',
    overflowY: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: 350
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginBottom: theme.spacing(2),
      maxHeight: 400
    },
    [theme.breakpoints.down('sm')]: {
      maxHeight: 300
    },
    // Custom scrollbar styling
    scrollbarWidth: 'thin',
    scrollbarColor: '#512EAB26 transparent',
    '&::-webkit-scrollbar': {
      width: 6,
      background: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#512EAB26',
      borderRadius: 3,
      border: 'none'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#512EAB40'
    },
    // Remove scrollbar arrows/buttons
    '&::-webkit-scrollbar-button': {
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent'
    }
  },
  right: {
    marginLeft: 20,
    flex: 1,
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      width: '100%'
    }
  },
  upNextSection: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    borderRadius: 8,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  upNextText: {
    fontWeight: 600,
    fontSize: '1rem',
    color: '#171717'
  },
  upNextIcon: {
    backgroundColor: '#3f51b5',
    color: 'white',
    width: 24,
    height: 24,
    '&:hover': {
      backgroundColor: '#303f9f'
    }
  }
}));

// AssignmentsDetailsComponent Styles
export const useAssignmentsDetailsStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: 380,
    padding: 10,
    boxSizing: 'border-box',
    paddingTop: '12px',
    paddingRight: '16px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    transform: 'rotate(0deg)',
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('lg')]: {
      width: 330
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 500
    },
    [theme.breakpoints.down('sm')]: {
      padding: 8,
      paddingTop: '10px',
      paddingRight: '12px',
      paddingBottom: '10px',
      paddingLeft: '12px'
    }
  },
  iconButton: {
    position: 'absolute !important',
    top: 8,
    right: 8,
    backgroundColor: '#fff !important',
    borderRadius: '50% !important',
    boxShadow: '0 0 4px rgba(0,0,0,0.2) !important',
    padding: 4
  },
  chaptersWrapper: {
    display: 'flex',
    overflowX: 'auto',
    paddingBottom: 8,
    gap: 8,
    margin: '8px 0',
    cursor: 'grab',
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none' // Chrome, Safari
    }
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 8
  },
  progressBar: {
    flexGrow: 1,
    marginRight: 8
  },
  percentText: {
    fontWeight: 500,
    color: theme.palette.text.secondary
  },
  footer: {
    display: 'flex',
    marginTop: 12,
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  dueInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  chip: {
    borderRadius: 4
  }
}));

// AssignmentsDetailsHeader Styles
export const useAssignmentsDetailsHeaderStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    backgroundColor: 'white',
    width: '100%',
    height: '100%',
    minHeight: 200
  },
  leftBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minWidth: 0,
    width: '100%'
  },
  rightBox: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 220
  },
  subHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    minWidth: 0,
    justifyContent: 'space-between',
    gap: 5
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  actionRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  title: {
    fontWeight: 600,
    fontSize: '1.5rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  cardRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 5,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 12
    }
  },
  cardBox: {
    flex: 1,
    minHeight: 150,
    display: 'flex',
    flexDirection: 'column'
  },
  completionLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    color: '#0D004D'
  },
  topicsCoveredLabel: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    color: '#171717'
  },
  progressBar: {
    height: 6,
    borderRadius: 5,
    backgroundColor: '#E8E6F3',
    '& .MuiLinearProgress-bar': {
      borderRadius: 5,
      backgroundColor: '#3f51b5'
    }
  },
  percentText: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontWeight: 500,
    color: theme.palette.text.secondary
  },
  statsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 15
  },
  timerBox: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  questionStats: {
    display: 'flex',
    flexDirection: 'row',
    gap: 5
  },
  scrollBox: {
    maxHeight: '80px',
    overflowY: 'auto',
    paddingRight: theme.spacing(1),
    scrollbarWidth: 'thin',
    scrollbarColor: '#512EAB26 transparent',
    borderRadius: 8,

    // Webkit-based browsers (Chrome, Safari, etc.)
    '&::-webkit-scrollbar': {
      width: 6,
      background: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#512EAB26',
      borderRadius: 3,
      border: 'none'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#512EAB40'
    },
    // Remove all scrollbar buttons/arrows
    '&::-webkit-scrollbar-button': {
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent'
    }
  },
  maxHeightCard: {
    maxHeight: 140,
    overflow: 'hidden',
    height: 140,
    display: 'flex',
    flexDirection: 'column'
  }
}));

// AssignmentsRightContentPanel Styles
export const useAssignmentsRightContentPanelStyles = makeStyles(theme => ({
  root: {
    borderRadius: 12,
    height: '100%',
    maxHeight: 500,
    padding: 5,
    overflowY: 'auto',
    backgroundColor: 'white',
    scrollbarWidth: 'thin',
    scrollbarColor: '#512EAB26 transparent',
    '&::-webkit-scrollbar': {
      width: 6,
      background: 'transparent'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#512EAB26',
      borderRadius: 3,
      border: 'none'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#512EAB40'
    },
    '&::-webkit-scrollbar-button': {
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent'
    }
  },
  headerBox: {
    padding: 5
  },
  tabContent: {
    marginTop: theme.spacing(2)
  },
  difficultTopics: {
    padding: theme.spacing(1),
    color: '#333',
    fontWeight: 500,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  }
}));

// StudentNeedingSupport Styles
export const useStudentNeedingSupportStyles = makeStyles(() => ({
  studentCardList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  topRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%'
  },
  nameText: {
    fontWeight: 600
  },
  chaptersWrapper: {
    display: 'flex',
    overflowX: 'auto',
    gap: 8,
    margin: '8px 0',
    cursor: 'grab',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  chip: {
    borderRadius: '4px !important',
    backgroundColor: '#FFE7E5 !important',
    color: '#B20900 !important',
    '&.MuiChip-root': {
      borderRadius: '4px !important',
      backgroundColor: '#FFE7E5 !important',
      color: '#B20900 !important'
    }
  }
}));
